import { IconButton, useColorMode, useColorModeValue } from '@chakra-ui/react';
import { MoonIcon, SunIcon } from '@chakra-ui/icons';

export function ColorModeToggle() {
  const { colorMode, toggleColorMode } = useColorMode();
  const hoverBg = useColorModeValue('blackAlpha.100', 'whiteAlpha.200');

  return (
    <IconButton
      aria-label={colorMode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
      variant='ghost'
      size='sm'
      onClick={toggleColorMode}
      icon={colorMode === 'light' ? <MoonIcon boxSize={4} /> : <SunIcon boxSize={4} />}
      _hover={{ bg: hoverBg }}
    />
  );
}
